import { render, staticRenderFns } from "./NumericalAnonymisationField.vue?vue&type=template&id=38bce3f2&"
import script from "./NumericalAnonymisationField.vue?vue&type=script&lang=ts&"
export * from "./NumericalAnonymisationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports